import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';

/**
 * Route für dynamische Aktivitäten-Seiten (/aktivitaeten/:slug).
 * Rendert CMS-Inhalte für den angegebenen Slug.
 * Bei nicht gefundener Seite wird automatisch die 404-Seite angezeigt.
 */
export const Route = createFileRoute('/aktivitaeten/$slug')({
  component: function AktivitaetenSlugRoute() {
    const { slug } = Route.useParams();
    return <CmsPageRenderer slug={slug} />;
  },
});
